import React from "react";
import TableHeader from "./components/TableHeader";
import TableBody from "./components/TableBody";
import Pagination from "./components/Pagination";
import { useTableSort } from "./hooks/useTableSort";

const ReusableTableDiff = ({
  headers,
  data,
  rowKey,
  defaultSortKey,
  tableClassName = "",
  headerClassName = "",
  rowClassName = "",
  tableActions,
  onPageChange,
  onPerPageChange,
  queries,
}) => {
  const { sortedData, sortConfig, handleSort } = useTableSort(
    data,
    defaultSortKey
  );

  const { dropdownIndex, toggleDropdown, handleActionClick } = tableActions;

  // Handle pagination actions
  const handleActionPerPage = (newPerPage) => {
    if (onPerPageChange) onPerPageChange(newPerPage);
  };

  const handleActionPage = (newPage) => {
    if (onPageChange) onPageChange(newPage);
  };

  return (
    <div className="w-full p-4 text-black font-ubuntu">
      <div className="bg-white p-4 rounded-t-md shadow-lg">
        <table className={`w-full ${tableClassName}`}>
          <TableHeader
            headers={headers}
            sortConfig={sortConfig}
            onSort={handleSort}
            headerClassName={headerClassName}
          />
          <TableBody
            data={sortedData}
            headers={headers}
            rowKey={rowKey}
            dropdownIndex={dropdownIndex}
            toggleDropdown={toggleDropdown}
            onActionClick={handleActionClick}
            rowClassName={rowClassName}
          />
        </table>
      </div>

      <Pagination
        queries={queries}
        onPageChange={handleActionPage}
        onPerPageChange={handleActionPerPage}
      />
    </div>
  );
};

export default ReusableTableDiff;
